import React from 'react';

import LogoutIcon from '@mui/icons-material/Logout';
import Box from '@mui/material/Box';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';

import { StyledNavItemButton } from './Sidebar.styles';

interface SidebarFooterProps {
  isCollapsed: boolean;
  onSignOut: () => void;
}

const SidebarFooter: React.FC<SidebarFooterProps> = ({ isCollapsed, onSignOut }) => (
  <Box sx={{ p: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
    {isCollapsed ? (
      <Tooltip title="Cerrar sesión" placement="right" arrow>
        <StyledNavItemButton
          onClick={onSignOut}
          aria-label="Cerrar sesión"
          sx={{ justifyContent: 'center', width: '100%', px: 1, mb: 1 }}
        >
          <ListItemIcon
            sx={{ minWidth: 0, color: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <LogoutIcon
              sx={(theme) => ({
                width: '20px',
                height: '20px',
                transform: 'rotate(180deg)',
                fill: theme.palette.grey[700],
              })}
            />
          </ListItemIcon>
        </StyledNavItemButton>
      </Tooltip>
    ) : (
      <StyledNavItemButton
        onClick={onSignOut}
        aria-label="Cerrar sesión"
        sx={{ justifyContent: 'flex-start', width: '100%', px: 1.5, mb: 1 }}
      >
        <ListItemIcon
          sx={{ minWidth: 40, color: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <LogoutIcon
            sx={(theme) => ({
              width: '20px',
              height: '20px',
              transform: 'rotate(180deg)',
              fill: theme.palette.grey[700],
            })}
          />
        </ListItemIcon>
        <ListItemText
          primary="Cerrar sesión"
          sx={(theme) => ({
            flex: 1,
            '& .MuiListItemText-primary': {
              fontSize: '16px',
              fontWeight: 400,
              [theme.breakpoints.up('xl')]: { fontSize: '18px' },
            },
          })}
        />
      </StyledNavItemButton>
    )}
  </Box>
);

export default React.memo(SidebarFooter);
